import React from "react"

import PopoverMenuOption from "../../../../../popover-menu/popover-menu/menu-option"
import {lexicalAlignText} from "../../../../actions/align-text"
import {AlignType} from "./align";

export default function ToolbarAlignMenu(props:any) {

    const onClick = (value:AlignType) => {
        lexicalAlignText(props.menuParams.editor, value)
    }

    return (
        <div className="ui5-popover-menu icon-fs-16" style={{minWidth:180}}>
            {_.map(props.menuParams.options, (option:any, index:number)=> {
                if (option === 'separator') {
                    return <div key={index} className="separator"/>
                } else {
                    return <PopoverMenuOption key       = {option.value}
                                              option    = {option}
                                              onClick   = {()=>onClick(option.value)}/>
                }
            })}
        </div>
    )
}